import { ChangeEvent, FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Chip } from '@mui/material';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';

function createData(date: string, id: string, type: string, amount: number, status: string) {
  return { date, id, type, amount, status };
}

type TableRow = {
  date: string;
  id: string;
  type: string;
  amount: number;
  status: string;
};

const makeChip = (status: string) => {
  if (status === 'FAILED') {
    return <Chip label={status} color="error" />;
  }
  return <Chip label={status} color="primary" />;
};

interface Props {
  transactions: any;
  page: number;
  onPageChange: (page: number) => void;
  rowsPerPage: number;
  onRowChange: (rows: number) => void;
}

export const AccountTable: FC<Props> = ({ transactions, page, onPageChange, rowsPerPage, onRowChange }) => {
  const { t } = useTranslation();
  const [rows, setRows] = useState<TableRow[]>([]);
  const generateTableFromData = async () => {
    if (!transactions) return;
    setRows([]);
    for (const row of transactions) {
      setRows((rows) => [...rows, createData(new Date(row.date).toLocaleDateString(), row.id, row.type, row.amount, row.status)]);
    }
    console.log('mangoTransactions:', transactions);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    onPageChange(newPage);
  };

  const handleChangeRowsPerPage = (event: ChangeEvent<HTMLInputElement>) => {
    onRowChange(Number(event.target.value));
    onPageChange(1);
    setRows([]);
  };

  useEffect(() => {
    generateTableFromData();
  }, [transactions]);

  return (
    <Paper>
      <TableContainer>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>{t('payment.account.table.creation')}</TableCell>
              <TableCell>{t('payment.account.table.transactionId')}</TableCell>
              <TableCell>{t('payment.account.table.type')}</TableCell>
              <TableCell>{t('payment.account.table.amount')}</TableCell>
              <TableCell align="right">{t('payment.account.table.status')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row: TableRow) => (
              <TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell component="th" scope="row">
                  {row.date}
                </TableCell>
                <TableCell align="left">{row.id}</TableCell>
                <TableCell align="left">{row.type}</TableCell>
                <TableCell align="left">€ {row.amount.toFixed(2)}</TableCell>
                <TableCell align="right">{makeChip(row.status)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={-1}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        nextIconButtonProps={
          rows.length < rowsPerPage
            ? {
                disabled: true,
              }
            : undefined
        }
      />
    </Paper>
  );
};
